export default __webpack_public_path__ + "d25849cf931d5ebdc3b73becd9068680.png";